<template>
  <div>
    <MainMenu
      v-if="!inAdmRouter"
      :hasAdminPermission="hasPermission(userPermissions['ADM_VIEW'])"
      :isReduced="isReduced"
      :handlerReduce="handlerReduce"
      @event-switch-menu="eventSwitchMenu"
    />
    <AdminMenu
      v-else-if="hasPermission(userPermissions['ADM_VIEW'])"
      :isReduced="isReduced"
      :handlerReduce="handlerReduce"
      @event-switch-menu="eventSwitchMenu"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import MainMenu from "@/views/App/Menu/MainMenu.vue";
import AdminMenu from "@/views/App/Menu/AdminMenu.vue";

import { USER_PERMISSIONS as userPermissions } from "@/utils/enumerate";
import { General } from "@/utils/constants";

export default {
  name: "Menu",

  components: {
    MainMenu,
    AdminMenu
  },

  props: {
    isReduced: {
      type: Boolean,
      default: true
    },
    handlerReduce: {
      type: Function,
      default: () => null
    }
  },

  data() {
    return {
      userPermissions,
      currentVisibleMenu: "MAIN",
      General
    };
  },

  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
      user: "getCurrentUser"
    }),
    inAdmRouter() {
      return (
        this.$route.path?.startsWith("/app/admin") ||
        this.$route.query.isAdmBookmark
      );
    }
  },

  methods: {
    eventSwitchMenu(goToMenu) {
      this.currentVisibleMenu = goToMenu;
      if (goToMenu === "MAIN") {
        this.$router.push("/app");
      } else if (goToMenu === "ADMIN") {
        this.$router.push("/app/admin");
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/variables";

.card-content {
  padding: 15px 10px 0 10px;
}
.menu {
  font-weight: 600;
  font-size: 0.9rem;
  .menu-list {
    li {
      font-size: 1rem;
      padding: 2px 0;

      .icon {
        vertical-align: text-top;
        padding: 6px 15px 2px 0;
      }
    }
    li > a {
      border-left: 2px solid transparent;

      &.is-active {
        border-left: 2px solid $color-12;
        background: $background-color;
      }
      &:hover {
        border-left: 2px solid $color-12;
        color: $color-12;
      }
    }
    li > ul {
      border: none;
      li > a {
        border: none;
        &:hover {
          border: none;
          background-color: transparent;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
